import { getFromLocalStorage, saveToLocalStorage } from "@/helpers/storage";
import DEFAULTS from "@/helpers/defaults";
const state = {
  editMode: false,
  selectionMode: "multiple",

  uiSettingsConfig: getFromLocalStorage("uiSettingsConfig") || DEFAULTS.uiSettingsConfig,
  customTabsConfig: getFromLocalStorage("customTabsConfig") || DEFAULTS.customTabsConfig,
  navigationConfig: getFromLocalStorage("navigationConfig") || DEFAULTS.navigationConfig,
  viewTemplatesConfig: getFromLocalStorage("viewTemplatesConfig") || DEFAULTS.viewTemplatesConfig,
};
const getters = {
  isEditMode(state) {
    return state.editMode;
  },
  getSelectionMode(state) {
    return state.selectionMode;
  },
  customTabsConfigJson(state) {
    return JSON.stringify(state.customTabsConfig, null, 2);
  },
  navigationConfigJson(state) {
    return JSON.stringify(state.navigationConfig, null, 2);
  },
  viewTemplatesConfigJson(state) {
    return JSON.stringify(state.viewTemplatesConfig, null, 2);
  },
  customTabsConfig(state) {
    return state.customTabsConfig;
  },
  uiSettingsConfig(state) {
    return state.uiSettingsConfig;
  },
  viewTemplatesConfig(state) {
    return state.viewTemplatesConfig;
  },
  navigationConfig(state) {
    return state.navigationConfig;
  },
  navigationFilters(state) {
    if (!state.navigationConfig || !state.navigationConfig.Filters) return [];
    return state.navigationConfig.Filters;
  },

  enabledProperties(state) {
    return state.uiSettingsConfig.enabledProperties;
  },
  enabledColorCode(state) {
    return state.uiSettingsConfig.enabledColorCode;
  },
  enabledIot(state) {
    return state.uiSettingsConfig.enabledIot;
  },
  enabledFilter(state) {
    return state.uiSettingsConfig.enabledFilter;
  },
};
const mutations = {
  changeEditMode(state, edit) {
    state.editMode = edit;
  },
  changeSelectionMode(state, mode) {
    state.selectionMode = mode;
  },
  changeCustomTabsConfig(state, json) {
    state.customTabsConfig = json;
  },
  changeUISettings(state, settings) {
    state.uiSettingsConfig = { ...settings };
  },

  changeNavigationConfig(state, json) {
    state.navigationConfig = json;
  },

  changeViewTemplatesConfig(state, json) {
    state.viewTemplatesConfig = json;
  },
};
const actions = {
  changeEditMode({ commit }, edit) {
    commit("changeEditMode", edit);
  },

  changeSelectionMode({ commit }, mode) {
    commit("changeSelectionMode", mode);
  },

  changeUISettings({ commit }, settings) {
    commit("changeUISettings", settings);
    saveToLocalStorage("uiSettingsConfig", settings);
  },

  changeCustomTabsJson({ commit }, parsed) {
    commit("changeCustomTabsConfig", parsed);
    saveToLocalStorage("customTabsConfig", parsed);
  },

  changeNavigationConfigJson({ commit }, parsed) {
    commit("changeNavigationConfig", parsed);
    saveToLocalStorage("navigationConfig", parsed);
  },
  
  changeViewTemplatesConfigJson({ commit }, parsed) {
    commit("changeViewTemplatesConfig", parsed);
    saveToLocalStorage("viewTemplatesConfig", parsed);
  },
};

const settings = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
export default settings;
